import Model from '../model';
import { IPart } from 'types';

export default class PartModel extends Model<IPart> {}
